import { useState } from "react"
import { Text } from "../../../components"
import { resolveAssetUrl } from "../../../helpers"
import { CrmClientRef, CrmRequest, PAGE_SIZE, ensureOk, getErrorMessage, usePagedList } from "../api"
import { ConfirmButton, ListStatus, Pager } from "../components"

interface CrmStore {
    id: number;
    title: string;
    subtitle: string;
    image: string;
    client_id: number | null;
    isMain: boolean;
    client: CrmClientRef | null;
    codes: {id: number; code: string}[];
}

export const StoresTab = ({request}: {request: CrmRequest}) => {
    const {items, loading, error, offset, setOffset, hasNext, reload} = usePagedList<CrmStore>(request, '/crm/get-stores', 'stores')
    const [busyId, setBusyId] = useState<number | null>(null)
    const [actionError, setActionError] = useState<string | null>(null)

    const deleteStore = async (storeId: number) => {
        setBusyId(storeId)
        setActionError(null)
        try {
            const res = await request(`/crm/delete-store?store_id=${storeId}`, {method: 'DELETE'})
            if (!res) return
            await ensureOk(res, 'Не удалось удалить страницу')
            if (items.length === 1 && offset > 0) setOffset(offset - PAGE_SIZE)
            else await reload()
        } catch (err) {
            setActionError(getErrorMessage(err, 'Не удалось удалить страницу'))
        } finally {
            setBusyId(null)
        }
    }

    return (
        <div className="crm-list">
            {actionError && <Text size="xs" color="accent">{actionError}</Text>}

            <ListStatus loading={loading} error={error} empty={items.length === 0} emptyText="Страниц нет" />

            {!loading && items.map((store) => (
                <div className="link-row admin-link-row" key={store.id}>
                    {store.image
                        ? <img className="admin-template-thumb" src={resolveAssetUrl(store.image)} alt="" />
                        : <span className="admin-template-thumb crm-thumb-empty" />}
                    <div className="admin-link-info">
                        <Text size="m" color="white">{store.title || 'Без названия'}</Text>
                        <span className="admin-link-metric">
                            {`#${store.id} · ${store.client ? `${store.client.login}${store.client.mail ? ` (${store.client.mail})` : ''}` : 'клиент не найден'}${store.subtitle ? ` · ${store.subtitle}` : ''}`}
                        </span>
                        <div className="crm-code-meta">
                            {store.isMain && <span className="admin-template-badge">Основная</span>}
                            {store.codes.length === 0 && <span className="admin-link-metric">Карт нет</span>}
                            {store.codes.length === 1 && (
                                <span className="crm-code-status crm-code-status-linked" title={store.codes[0].code}>
                                    {`Карта #${store.codes[0].id}`}
                                </span>
                            )}
                            {store.codes.length > 1 && (
                                <details className="crm-codes-dropdown">
                                    <summary className="crm-code-status crm-code-status-linked">{`Карты: ${store.codes.length}`}</summary>
                                    <div className="crm-codes-dropdown-list">
                                        {store.codes.map((code) => (
                                            <div key={code.id} className="crm-codes-dropdown-item">
                                                <span className="admin-link-metric">{`#${code.id}`}</span>
                                                <span className="crm-codes-dropdown-code">{code.code}</span>
                                            </div>
                                        ))}
                                    </div>
                                </details>
                            )}
                        </div>
                    </div>
                    <div className="crm-row-actions">
                        <button
                            type="button"
                            className="admin-edit-btn"
                            onClick={() => window.open(`${window.location.origin}/${store.id}`, '_blank', 'noopener,noreferrer')}
                        >
                            <Text size="xs" color="lightGray">Открыть</Text>
                        </button>
                        <ConfirmButton label="Удалить" disabled={busyId === store.id} onConfirm={() => deleteStore(store.id)} />
                    </div>
                </div>
            ))}

            <Pager offset={offset} hasNext={hasNext} loading={loading} onChange={setOffset} />
        </div>
    )
}
